import React from 'react';
import ExternalLink from '../_styles/images/ExternalLink.png'

export default function ShowMeMath() {
  return (
    <div className="show-me-math">
          <a
                className="show-me-math-link"
                href={"https://www.commutewithenterprise.com/en/show-me-the-math.html"}
                target="_blank"
                rel="noopener noreferrer"
              >
                SHOW ME THE MATH
                </a>
                <img src={ExternalLink} className='external-link' />
    </div>
  );
}